import { Box, FormControl, FormLabel, Heading, Select, VStack, useColorModeValue, Input, Text } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { format } from "date-fns";

const StaffDateSection = ({ staffDateData, onUpdate }) => {
  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const labelBgColor = useColorModeValue("gray.100", "gray.700");

  const [staffDate, setStaffDate] = useState({
    staffId: "",
    jobDate: new Date().toISOString().split("T")[0],
    jobTime: format(new Date(), "HH:mm"),
    eta: "",
    etaTime: "17:00",
  });

  // Staff list - this should ideally come from a database or config
  const staffList = [
    { id: "JD", name: "John Doe" },
    { id: "JS", name: "Jane Smith" },
    { id: "WB", name: "Web Booking" },
  ];

  useEffect(() => {
    if (staffDateData) {
      const jobDateTime = staffDateData.jobDate ? new Date(staffDateData.jobDate) : new Date();
      const etaDate = staffDateData.eta ? new Date(staffDateData.eta) : null;

      setStaffDate({
        staffId: staffDateData.staffId || "",
        jobDate: jobDateTime.toISOString().split("T")[0],
        jobTime: format(jobDateTime, "HH:mm"),
        eta: etaDate ? etaDate.toISOString().split("T")[0] : "",
        etaTime: etaDate ? format(etaDate, "HH:mm") : "17:00",
      });
    }
  }, [staffDateData]);

  const handleChange = (field, value) => {
    const updated = { ...staffDate, [field]: value };
    setStaffDate(updated);

    // Convert back to combined datetime for parent
    const jobDateTime = new Date(`${updated.jobDate}T${updated.jobTime}`);
    const etaDateTime = updated.eta ? new Date(`${updated.eta}T${updated.etaTime}`) : null;

    // Map to uppercase field names for parent
    onUpdate({
      STAFF_ID: updated.staffId,
      JOB_DATE: jobDateTime,
      ETA: etaDateTime,
    });
  };

  const handleEtaDateChange = (value) => {
    // Ensure ETA is not before job date
    const etaDate = new Date(value);
    const jobDate = new Date(staffDate.jobDate);

    if (etaDate < jobDate) {
      // Set ETA to job date if it's before
      handleChange("eta", staffDate.jobDate);
    } else {
      handleChange("eta", value);
    }
  };

  const formatEtaDisplay = () => {
    if (!staffDate.eta) return "Not set";
    const etaDate = new Date(`${staffDate.eta}T${staffDate.etaTime}`);
    return format(etaDate, "EEE, d/MM/yyyy 'after' h:mm aaa");
  };

  return (
    <Box bg={bgColor} p={3} borderRadius='md' border='1px' borderColor={borderColor} width='100%'>
      <Heading size='sm' bg={labelBgColor} p={2} borderRadius='md' mb={3}>
        Staff &amp; Dates
      </Heading>

      <VStack spacing={2} alignItems='stretch'>
        <FormControl isRequired>
          <FormLabel fontSize='xs'>Staff Member</FormLabel>
          <Select
            size='sm'
            value={staffDate.staffId}
            onChange={(e) => handleChange("staffId", e.target.value)}
            placeholder='Select staff member'
          >
            {staffList.map((staff) => (
              <option key={staff.id} value={staff.id}>
                {staff.name}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel fontSize='xs'>Job Date</FormLabel>
          <Input
            size='sm'
            type='date'
            value={staffDate.jobDate}
            onChange={(e) => handleChange("jobDate", e.target.value)}
          />
        </FormControl>

        <FormControl>
          <FormLabel fontSize='xs'>Job Time</FormLabel>
          <Input
            size='sm'
            type='time'
            value={staffDate.jobTime}
            onChange={(e) => handleChange("jobTime", e.target.value)}
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel fontSize='xs'>ETA Date</FormLabel>
          <Input
            size='sm'
            type='date'
            value={staffDate.eta}
            onChange={(e) => handleEtaDateChange(e.target.value)}
            min={staffDate.jobDate}
          />
        </FormControl>

        <FormControl>
          <FormLabel fontSize='xs'>ETA Time</FormLabel>
          <Input
            size='sm'
            type='time'
            value={staffDate.etaTime}
            onChange={(e) => handleChange("etaTime", e.target.value)}
          />
        </FormControl>

        {staffDate.eta && (
          <Box bg={labelBgColor} p={2} borderRadius='md'>
            <Text fontSize='sm' fontWeight='medium'>
              ETA: {formatEtaDisplay()}
            </Text>
          </Box>
        )}
      </VStack>
    </Box>
  );
};

export default StaffDateSection;
